import { getTodayDate } from '../get-today-date/get-today-date';

interface AlterDateData {
  date?: Date;
  days?: number;
  months?: number;
  years?: number;
}

/**
 * Alter a date object by adding/substracting days/months/years
 * @public
 *
 * @param args - The arguments to operate in this function, if no date is passed then {@link getTodayDate} is used as default date
 *
 * @returns A new date with the operations applied
 *
 * @example
 * ```ts
 * const result = alterDate({
 *  date: new Date(2021, 1, 1),
 * days: 365,
 * });
 * console.log(result);
 * // -> Tue Feb 01 2022 00:00:00 GMT+0100 (Central European Standard Time)
 * ```
 */
function alterDate({
  date,
  days = 0,
  months = 0,
  years = 0,
}: AlterDateData = {}): Date {
  const newDate =
    date instanceof Date ? new Date(date.getTime()) : getTodayDate();

  if (days) {
    newDate.setDate(newDate.getDate() + days);
  }

  if (months) {
    newDate.setMonth(newDate.getMonth() + months);
  }

  if (years) {
    newDate.setFullYear(newDate.getFullYear() + years);
  }

  return newDate;
}

export { alterDate };
